module.exports = __webpack_public_path__ + "70254cc6fd8c8f370090f30923e6f596.svg";